import { isProduction } from 'shared/lib';
import { sendMonitoringEvent } from 'shared/lib/sendMonitoringEvent';

import type { IInitialEvent } from '../types';

import { formatEventLabelWithQuery } from './formatEventLabelWithQuery';
import { formatValue } from './formatValue';

export const sendEventToGA = (event: IInitialEvent, isMonitoringEvent = false) => {
  const currentWindow = window;

  const data = {
    event: event.event,
    eventCategory: event.eventCategory || 'Кредиты',
    eventAction: formatValue(event.eventAction) || '',
    eventLabel: formatEventLabelWithQuery(formatValue(event.eventLabel), currentWindow),
    eventData: event.eventData,
    eventValue: event.eventValue,
  };

  if (isMonitoringEvent) {
    sendMonitoringEvent({
      type: 'EVENT',
      payload: {
        ...data,
        eventLabel: data.eventLabel || '',
        eventValue: data.eventValue ? String(data.eventValue) : '',
      },
    });
  }

  if (isProduction()) {
    if (typeof currentWindow.sravniDataLayer === 'undefined') {
      currentWindow.sravniDataLayer = [];
    }

    if (event.eventCallback && currentWindow.sravniDataLayer.push === Array.prototype.push) {
      event.eventCallback();
    }

    currentWindow.sravniDataLayer.push(data);
  } else {
    const { eventData, ...tableData } = data;
    // eslint-disable-next-line no-console
    console.groupCollapsed(`Analytics Event: ${formatValue(event.eventAction)}`);
    // eslint-disable-next-line no-console
    console.table(tableData);
    // eslint-disable-next-line no-console
    console.log({ eventData });
    // eslint-disable-next-line no-console
    console.groupEnd();
  }
};
